// ABOUTME: Flash/lightning icon for AI-powered features and build workout actions
// ABOUTME: Supports className, size, and color customization

interface FlashIconProps {
  className?: string
  size?: number
  color?: string
}

export const FlashIcon = ({ className = "", size = 16, color = "white" }: FlashIconProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.03879 0.836813C9.2012 0.887887 9.34307 0.989438 9.44379 1.1267C9.5445 1.26396 9.5988 1.42977 9.59879 1.60001V5.60001H12.7988C12.9451 5.59995 13.0887 5.64002 13.2138 5.71587C13.339 5.79172 13.4409 5.90045 13.5085 6.03021C13.5762 6.15997 13.6069 6.3058 13.5975 6.45183C13.588 6.59785 13.5386 6.73848 13.4548 6.85841L7.85479 14.8584C7.75733 14.998 7.61786 15.1029 7.45667 15.1578C7.29547 15.2127 7.12097 15.2147 6.95855 15.1636C6.79613 15.1125 6.65426 15.0108 6.55359 14.8735C6.45291 14.7362 6.39869 14.5703 6.39879 14.4V10.4H3.19879C3.05246 10.4001 2.90891 10.36 2.78377 10.2842C2.65863 10.2083 2.55669 10.0996 2.48904 9.96982C2.4214 9.84006 2.39064 9.69423 2.40012 9.5482C2.40959 9.40217 2.45894 9.26154 2.54279 9.14161L8.14279 1.14161C8.2404 1.00224 8.3799 0.897623 8.54103 0.842954C8.70216 0.788285 8.87653 0.786414 9.03879 0.837613V0.836813Z"
      fill={color}
    />
  </svg>
)
